var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { Collector } from "@dp/byted-tea-sdk-oversea";
import { Region, SDK_BID, VERSION } from "../constants/env";
const getTeaRegionalConfig = (region) => {
  let defaultConfig = {};
  switch (region) {
    case Region.US_EASTRED: {
      defaultConfig = {
        channel: "in",
        channel_type: "tcpy",
        channel_domain: "https://mon-i18n.tiktokv.com"
      };
      break;
    }
    case Region.EU_TTP: {
      defaultConfig = {
        channel: "ie",
        channel_type: "ttp",
        channel_domain: "https://mcs-ie.tiktokw.eu"
      };
      break;
    }
    case Region.EU_TTP2: {
      defaultConfig = {
        channel: "ie2",
        channel_type: "ttp",
        channel_domain: "https://mcs-ie2.tiktokw.eu"
      };
      break;
    }
    case Region.US_TTP: {
      defaultConfig = {
        channel_type: "ttp",
        channel_domain: "https://mcs.tiktokv.us"
      };
      break;
    }
    case Region.US_TTP2: {
      defaultConfig = {
        channel_type: "ttp",
        channel_domain: "https://mcs.tiktokw.us"
      };
      break;
    }
    case Region.SINGAPORE_CENTRAL: {
      defaultConfig = {
        channel: "sg",
        channel_type: "tcpy",
        channel_domain: "https://mcs-sg.tiktokv.com"
      };
      break;
    }
    case Region.US_EAST: {
      defaultConfig = {
        channel: "va",
        channel_type: "tcpy",
        channel_domain: "https://mcs-va.tiktokv.com"
      };
      break;
    }
    default:
      break;
  }
  return defaultConfig;
};
const hasValidConfig = (config) => {
  return !!(config && config.channel_type && (config.channel || config.channel_domain));
};
const createTeaAndInit = (config) => {
  let teaInstance = null;
  try {
    const { appId, tea, region, debug } = config;
    const defaultConfig = getTeaRegionalConfig(region);
    const finalConfig = __spreadValues(__spreadValues({}, defaultConfig), tea != null ? tea : {});
    if (hasValidConfig(finalConfig)) {
      teaInstance = new Collector(`${SDK_BID}_${VERSION}_${Date.now()}`);
      teaInstance.init(__spreadValues({
        app_id: appId != null ? appId : 1988,
        // TikTok Web AppID
        log: debug
      }, finalConfig));
      teaInstance.start();
    }
  } catch (e) {
  }
  return teaInstance;
};
export {
  createTeaAndInit
};
